const shape = {
  borderRadius: 4
};
export default shape;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/createTheme/shape.js
// module id = 856
// module chunks = 31